import { createSelector } from "reselect"

import { selectActiveTeeupId } from "@selectors/activeTeeup"

export const selectTasksState = state => state?.tasks?.byCoId || {}

export const selectTasksByCoId = coId =>
  createSelector(selectTasksState, byCoId => byCoId[coId]?.items || [])

export const selectActiveTeeupTasks = createSelector(
  selectTasksState,
  selectActiveTeeupId,
  (byCoId, coId) => byCoId[coId]?.items || []
)

export const selectActiveTeeupTasksLoading = createSelector(
  selectTasksState,
  selectActiveTeeupId,
  (byCoId, coId) => !!byCoId[coId]?.loading
)

// The reschedule-dependency banner: any INCOMPLETE task on the active TeeUp that carries a
// consequence -- surfaced to every participant while unmet, clears the moment it's completed.
export const selectActiveTeeupRescheduleTasks = createSelector(
  selectActiveTeeupTasks,
  tasks =>
    (tasks || []).filter(t => !!t.consequence && !t.completed_at)
)

export const selectMyTasks = state => state?.tasks?.myTasks?.items || []
export const selectMyTasksLoading = state => !!state?.tasks?.myTasks?.loading
